import cn from 'classnames';
import React, { useCallback } from 'react';

import { UploadedFontData } from 'editor/src/store/fonts/types';

import IconWarning2 from 'editor/src/component/Icon/IconWarning2';

import styles from './index.module.scss';

function sanitizeUrl(url: string | undefined | null): string | undefined {
  if (!url) {
    return undefined;
  }
  const trimmed = url.trim();
  if (!trimmed) {
    return undefined;
  }
  try {
    const parsed = new URL(trimmed, window.location.origin);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.toString();
    }
  } catch {
    // Ignore invalid URLs
  }
  return undefined;
}

interface Props {
  font: UploadedFontData;
  isActive: boolean;
  onSelect: (fontFile: string) => void;
  // TODO: Re-enable when delete API is ready (Phase 2)
  // onDelete: (fontFile: string) => void;
}

function UploadedFontItem({ font, isActive, onSelect }: Props) {
  const handleClick = useCallback(() => {
    onSelect(font.fontFile);
  }, [font.fontFile, onSelect]);

  return (
    <div
      className={cn(styles.uploadedFontItem, 'cy-uploaded-font', { [styles.active]: isActive })}
      onClick={handleClick}
    >
      <div className={styles.fontName}>
        {sanitizeUrl(font.previewUrl) ? (
          <img src={sanitizeUrl(font.previewUrl)} alt={font.name} className={styles.previewImage} loading="lazy" />
        ) : (
          <span style={font.isProtected ? undefined : { fontFamily: font.fontFile }}>{font.name}</span>
        )}
        {font.hasWarning && <IconWarning2 className={styles.warningIcon} />}
      </div>
      {font.isProtected && <span className={styles.protectedBadge}>🔒</span>}
      {/* TODO: Enable delete button when delete API is ready (Phase 2)
      {isHovered && (
        <button
          type="button"
          className={styles.deleteButton}
          onClick={handleDeleteClick}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.5 3V2.5C4.5 1.94772 4.94772 1.5 5.5 1.5H10.5C11.0523 1.5 11.5 1.94772 11.5 2.5V3M2.5 3.5H13.5M3.5 3.5V13.5C3.5 14.0523 3.94772 14.5 4.5 14.5H11.5C12.0523 14.5 12.5 14.0523 12.5 13.5V3.5"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )} */}
    </div>
  );
}

export default React.memo(UploadedFontItem);
